import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_960_4037)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M14.905 16.319C13.549 17.372 11.847 18 10 18C5.585 18 2 14.415 2 10C2 5.585 5.585 2 10 2C14.415 2 18 5.585 18 10C18 11.847 17.372 13.549 16.319 14.905L22.414 21H19.586L14.905 16.319ZM10 4C13.311 4 16 6.689 16 10C16 13.311 13.311 16 10 16C6.689 16 4 13.311 4 10C4 6.689 6.689 4 10 4Z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_960_4037" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "24",
      height: "24",
      fill: "white"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}